export default "__VITE_ASSET__D$G003bF__"